/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_To_BInputs */

const en_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy to B`)
};

const fr_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier vers B`)
};

const de_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopie an B`)
};

const it_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia su B`)
};

const ru_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копия в B`)
};

const es_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar a B`)
};

const zh_cn2_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制到 B`)
};

const ja_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bにコピー`)
};

const hi_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B में कॉपी करें`)
};

const pt_pt2_compare_event_groups_copy_to_b = /** @type {(inputs: Compare_Event_Groups_Copy_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cópia para B`)
};

/**
* | output |
* | --- |
* | "Copy to B" |
*
* @param {Compare_Event_Groups_Copy_To_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_to_b = /** @type {((inputs?: Compare_Event_Groups_Copy_To_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_To_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_copy_to_b(inputs)
	if (locale === "de") return de_compare_event_groups_copy_to_b(inputs)
	if (locale === "it") return it_compare_event_groups_copy_to_b(inputs)
	if (locale === "ru") return ru_compare_event_groups_copy_to_b(inputs)
	if (locale === "es") return es_compare_event_groups_copy_to_b(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_copy_to_b(inputs)
	if (locale === "ja") return ja_compare_event_groups_copy_to_b(inputs)
	if (locale === "hi") return hi_compare_event_groups_copy_to_b(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_copy_to_b(inputs)
	return en_compare_event_groups_copy_to_b(inputs)
});